import { React, useEffect, useState } from 'react';
import axios from '../../utils/axiosInterceptor';
import { useSelector } from "react-redux";
import { useNavigate, Link } from 'react-router-dom';

import {
    Container, Box, Typography, Divider, Grid, Paper, Button, FormControl, TextField,
    Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';

import {
    DataGrid,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    GridToolbar,
    useGridSelector,
} from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
import useWindowDimensions from '../../utils/functions/useWindowDimensions';

const Proveedores = () => {

    const auth = useSelector((state) => state.auth);
    let navigate = useNavigate();

    const [data, setData] = useState([
        { name: 'Cliente 1', rfc: 'RFC1', email: 'email1', phone: 'phone1', address: 'address1', contact: 'contact1', _id: '1' },
        { name: 'Cliente 2', rfc: 'RFC2', email: 'email2', phone: 'phone2', address: 'address2', contact: 'contact2', _id: '2' },
        { name: 'Cliente 3', rfc: 'RFC3', email: 'email3', phone: 'phone3', address: 'address3', contact: 'contact3', _id: '3' },
        { name: 'Cliente 4', rfc: 'RFC4', email: 'email4', phone: 'phone4', address: 'address4', contact: 'contact4', _id: '4' },
        { name: 'Cliente 5', rfc: 'RFC5', email: 'email5', phone: 'phone5', address: 'address5', contact: 'contact5', _id: '5' },
        { name: 'Cliente 6', rfc: 'RFC6', email: 'email6', phone: 'phone6', address: 'address6', contact: 'contact6', _id: '6' },
    ]);
    const [data2, setData2] = useState([]);

    const [_id, setId] = useState(''); // for edit client
    const [name, setName] = useState('');
    const [rfc, setRfc] = useState('');
    const [address, setAddress] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [contact, setContact] = useState('');
    const [currentSupplier, setCurrentSupplier] = useState({});
    const [edit, setEdit] = useState(false);

    const [search, setSearch] = useState('');
    const [searchData, setSearchData] = useState([{}]);

    const [open, setOpen] = useState(false); // for delete client

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' }); // for custom alert message

    const { height } = useWindowDimensions();

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Proveedores';
    }, [auth])

    // for custom alert message
    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            const res = await axios.get('/api/suppliers');
            if (res.status === 200) {
                setData(res.data);
                setData2(res.data);
                setSearchData(res.data.map((client) => ({ data: `${client.name} ${client.rfc} ${client.contact}`, id: client._id })));
            }
        } catch (error) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al obtener la informacion de los proveedores, intentelo mas tarde', severity: 'error' } });
            console.log(error);
        }
    }

    useEffect(() => {
        if (edit) {
            setId(currentSupplier._id);
            setName(currentSupplier.name);
            setRfc(currentSupplier.rfc);
            setAddress(currentSupplier.address);
            setEmail(currentSupplier.email);
            setPhone(currentSupplier.phone);
            setContact(currentSupplier.contact);
        }
    }, [edit, currentSupplier])

    const handleEditSupplier = (supplier) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setCurrentSupplier(supplier);
        setEdit(true);
    }

    const handleSaveSupplier = async (e) => {
        e.preventDefault();
        const supplier = {
            name: name,
            rfc: rfc,
            address: address,
            email: email,
            phone: phone,
            contact: contact
        }

        let res;
        if (edit) {
            try {
                res = await axios.post(`/api/suppliers/${currentSupplier._id}`, { supplier: supplier });
                if (res.status === 200) {
                    setApiRes(state => { return { ...state, show: true, message: 'Proveedor actualizado correctamente', severity: 'success' } });
                    getData();
                    clearForm();
                }
            } catch (error) {
                setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al actualizar el proveedor, intentelo mas tarde', severity: 'error' } });
                console.log(error);
                clearForm();
            }
        } else {
            try {
                res = await axios.post('/api/suppliers', { supplier: supplier });
                if (res.status === 200) {
                    setApiRes(state => { return { ...state, show: true, message: 'Proveedor agregado correctamente', severity: 'success' } });
                    getData();
                    clearForm();

                }
            } catch (error) {
                setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al agregar el proveedor, intentelo mas tarde', severity: 'error' } });
                console.log(error);
                clearForm();
            }
        }
    }

    const clearForm = () => {
        setEdit(false);
        setId('');
        setName('');
        setRfc('');
        setAddress('');
        setEmail('');
        setPhone('');
        setContact('');
    }

    useEffect(() => {
        const delayTimer = setTimeout(() => {
            if (search === '' || search.length < 2) {
                setData(data2);
            } else {
                try {
                    const tmp = new RegExp(search, 'i');
                    const supp = searchData.filter(x => tmp.test(x.data));
                    const newData = [];
                    supp.forEach(supplier => {
                        if (Object.keys(supplier).length !== 0) {
                            const filteredData = data2.filter(d => d._id === supplier.id);
                            if (filteredData.length > 0) {
                                newData.push(filteredData[0]);
                            }
                        }
                    });
                    setData(newData);

                } catch {
                    setData(data2);
                }
            }
        }, 250);

        return () => {
            clearTimeout(delayTimer);
        };
    }, [search, data2]);

    const renderSuppliers = () => {
        return (
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField multiline id='search' label="Buscar proveedor" variant="outlined" value={search} onChange={(e) => setSearch(e.target.value)} />
                        </FormControl>
                    </Grid>
                </Grid>
                <br />
                <DataGrid
                    autoPageSize={true}
                    sx={{ '& .MuiButtonBase-root': { color: 'comp.gray' }, '& .MuiDataGrid-row': { backgroundColor: 'comp.tableBg', color: 'text.primary', height: 'auto' }, '& .MuiDataGrid-columnHeader': { backgroundColor: 'comp.tableHeaderBg', color: 'text.primary' } }}
                    style={{ height: `${height - 120}px`, width: '100%', overflow: 'hidden' }}
                    rows={data}
                    density='standard'
                    getRowId={(row) => row._id}
                    onCellDoubleClick={(e) => { handleEditSupplier(e.row) }}
                    columns={[
                        { field: 'name', flex: 1, headerName: 'Proveedor', align: 'center', headerAlign: 'center', minWidth: 200 },
                        { field: 'rfc', flex: 1, headerName: 'RFC', align: 'center', headerAlign: 'center', minWidth: 200 },
                        { field: 'email', flex: 1, headerName: 'Correo', align: 'center', headerAlign: 'center', minWidth: 200, },
                        { field: 'phone', flex: 1, headerName: 'Telefono', align: 'center', headerAlign: 'center', minWidth: 200, },
                        { field: 'contact', flex: 1, headerName: 'Contacto', align: 'center', headerAlign: 'center', minWidth: 200, },
                        {
                            field: 'id',
                            headerName: 'Acción',
                            headerAlign: 'center',
                            align: 'center',
                            sortable: false,
                            filterable: false,
                            disableColumnMenu: true,
                            minWidth: 125,
                            renderCell: (row) => (
                                <>
                                    <Button sx={{ minWidth: '50px' }} variant='contained' color='primary' className='m-1' onClick={() => handleEditSupplier(row.row)}>&nbsp;<i className='fa fa-edit' style={{ color: '#FFF' }}></i>&nbsp;</Button>
                                    <Button sx={{ minWidth: '50px' }} variant='contained' color='error' className='m-1' onClick={() => handleClickOpen(row.row)}>&nbsp;<i className='fa fa-trash-alt' style={{ color: '#FFF' }}></i>&nbsp;</Button>
                                </>
                            )
                        },
                    ]}
                    pagination
                    slots={{
                        pagination: CustomPagination,
                        toolbar: GridToolbar
                    }}
                    initialState={{
                        ...data.initialState,
                        pagination: { paginationModel: { pageSize: 25 } },
                    }}
                />
            </div>
        )
    }

    const handleClickOpen = (client) => {
        setCurrentSupplier(client);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentSupplier({});
        clearForm();
    };

    const handleDeleteClient = async () => {
        try {
            const res = await axios.delete(`/api/suppliers/${currentSupplier._id}`);
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Proveedor eliminado correctamente', severity: 'success' } });
                getData();
                clearForm();
                handleClose();
            }
        } catch (error) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al eliminar al proveedor, intentelo mas tarde', severity: 'error' } });
            console.log(error);
            clearForm();
            handleClose();
        }
    }

    const renderDeleteClient = () => {
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={handleClose}
                >
                    <DialogTitle>Eliminar proveedor</DialogTitle>
                    <DialogContent>
                        <Typography variant='body1'>¿Está seguro que desea eliminar al proveedor <strong>{currentSupplier.name}</strong>?</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancelar</Button>
                        <Button onClick={handleDeleteClient} color='error'>Eliminar</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
            <Paper sx={{ padding: '24px 0px' }} elevation={3}>
                <Container maxWidth='xl'>
                    <Box className='text-center' >
                        <Typography variant='h5' style={{ fontWeight: 700 }}>Proveedores</Typography>
                    </Box>

                    <Button size='small' variant='outlined' onClick={() => navigate('/clientes')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                    <Divider className='my-3' textAlign="left">
                        <CustomChip variant='outlined' estatus='AUTORIZADO' label='Agregar proveedor' className='text-bold' />
                    </Divider>

                    <form onSubmit={(e) => handleSaveSupplier(e)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField multiline label="Nombre o Razón Social" variant="outlined" value={name} onChange={(e) => setName(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={2}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="RFC" variant="outlined" value={rfc} onChange={(e) => setRfc(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Correo electrónico" variant="outlined" value={email} onChange={(e) => setEmail(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Direccion" multiline variant="outlined" value={address} onChange={(e) => setAddress(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={2}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Telefono" variant="outlined" value={phone} onChange={(e) => setPhone(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Contacto" variant="outlined" value={contact} onChange={(e) => setContact(e.target.value)} />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <hr></hr>
                        {edit ?
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <Button variant="contained" color="success" type='submit'>Actualizar proveedor &nbsp; <i className="fad fa-save"></i></Button>
                                </Grid>
                            </Grid> :
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <Button variant="contained" color="success" type='submit'>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                                </Grid>
                            </Grid>
                        }
                    </form>

                    <Divider className='my-3' textAlign="left">
                        <CustomChip variant='outlined' estatus='AUTORIZADO' label='Buscar proveedores' className='text-bold' />
                    </Divider>

                    {renderSuppliers()}
                    {renderDeleteClient()}

                </Container>
            </Paper>
            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
        </Container>
    )
}

function Pagination({ page, onPageChange, className }) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
        <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event, newPage - 1);
            }}
        />
    );
}

function CustomPagination(props) {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
}

export default Proveedores;